import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SuperbuySpreadsheetGuide from "@/pages/article/page";
import ArticleDetail from "@/pages/article-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "/article/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;